import {
  CUSTOM_PERSONAL_MESSAGE_MAX_CHARACTERS,
  TEXTFIELD_MAX_CHARACTERS,
} from './constraints'

import { LABEL_NO_MESSAGE_REQUIRED } from '../types/product'

export const ERROR_CUSTOM_AMOUNT_INVALID =
  'Please enter an amount between ${minAmount} and ${maxAmount}' // {minAmount} and {maxAmount} to be replaced during runtime with values from GraphQL API / eCommerce platform
export const ERROR_CUSTOM_MESSAGE_REQUIRED = `Please enter a custom message, or select '${LABEL_NO_MESSAGE_REQUIRED}'`
export const ERROR_AMOUNT_REQUIRED = 'Please select an amount'
export const ERROR_RECIPIENT_NAME = `Please keep recipient name under ${TEXTFIELD_MAX_CHARACTERS} characters`
export const ERROR_RECIPIENT_NAME_REQUIRED = 'Please enter a recipient name'
export const ERROR_RECIPIENT_REQUIRED = 'Please select a recipient'
export const ERROR_FROM_NAME = `Please keep sender name under ${TEXTFIELD_MAX_CHARACTERS} characters`
export const ERROR_FROM_NAME_REQUIRED = 'Please enter your name'
export const ERROR_CUSTOM_PERSONAL_MESSAGE = `Please enter a message of ${CUSTOM_PERSONAL_MESSAGE_MAX_CHARACTERS} characters or less`
export const ERROR_EMAIL_MISSING = 'Please enter a valid email address'
export const ERROR_EMAIL_INVALID = 'Please enter a valid email address'
export const ERROR_MOBILE_NUMBER_MISSING = 'Please enter a mobile number'
export const ERROR_MOBILE_NUMBER_INVALID = 'Mobile number is invalid'
export const ERROR_DELIVERY_DATE_INVALID =
  'Please enter a valid future date in DD/MM/YYYY format'
export const createErrorDeliveryDateValidRangeExceeded = (
  DELIVERY_DATE_MAX_FUTURE_DATE_MONTHS: number
): string =>
  `Please select a delivery date occurring within the next ${DELIVERY_DATE_MAX_FUTURE_DATE_MONTHS} months`
export const ERROR_DELIVERY_METHOD_REQUIRED = 'Please select a delivery method'
export const TERMS_AND_CONDITIONS_REQUIRED =
  'You must accept the Terms & Conditions and the Privacy Statement'
export const createErrorMaximumStringLengthExceeded = (
  MAXIMUM_STRING_LENGTH: number
): string => `Please enter fewer than ${MAXIMUM_STRING_LENGTH} characters`
